import { Link } from 'react-router-dom';
import { guidesList } from '@/mocks/guides';

const QUICK_ENTRIES = [
  { label: '角色攻略', to: '/characters', icon: 'ri-user-star-line', desc: '全角色培养' },
  { label: '活动专题', to: '/events', icon: 'ri-calendar-event-line', desc: '福利与时间' },
  { label: '版本更新', to: '/updates', icon: 'ri-history-line', desc: '版本改动' },
  { label: '深渊攻略', to: '/search?q=深渊', icon: 'ri-sword-line', desc: '满星阵容' },
  { label: '新手入门', to: '/search?q=新手', icon: 'ri-book-open-line', desc: '入坑指南' },
  { label: '圣遗物', to: '/search?q=圣遗物', icon: 'ri-treasure-map-line', desc: '词条速查' },
];

export default function SidePanel() {
  const hot = guidesList.slice(0, 5);

  return (
    <div className="space-y-6">
      <div className="rounded-xl border border-background-200 bg-background-50 p-5">
        <h3 className="font-heading text-base font-bold text-foreground-950">
          <a href="#quick-entry">角色与玩法快捷入口</a>
        </h3>
        <div className="mt-4 grid grid-cols-2 gap-2.5">
          {QUICK_ENTRIES.map((entry) => (
            <Link
              key={entry.label}
              to={entry.to}
              className="group flex cursor-pointer flex-col gap-1.5 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 hover:bg-primary-50"
            >
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${entry.icon} text-base`}></i>
              </span>
              <span className="text-sm font-label font-medium text-foreground-900">{entry.label}</span>
              <span className="text-[11px] text-foreground-500">{entry.desc}</span>
            </Link>
          ))}
        </div>
      </div>

      <div className="rounded-xl border border-background-200 bg-background-50 p-5">
        <div className="flex items-center justify-between">
          <h3 className="font-heading text-base font-bold text-foreground-950">
            <a href="#hot-column">热门专栏</a>
          </h3>
          <Link to="/characters" className="cursor-pointer text-xs text-primary-700 transition-colors hover:text-primary-600">
            更多
          </Link>
        </div>
        <ul className="mt-3 divide-y divide-background-100">
          {hot.map((guide, index) => (
            <li key={guide.id}>
              <Link to={`/guides/${guide.id}`} className="group flex cursor-pointer items-start gap-3 py-3">
                <span
                  className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded text-[11px] font-label ${
                    index < 3 ? 'bg-accent-500 text-foreground-950' : 'bg-secondary-100 text-secondary-800'
                  }`}
                >
                  {index + 1}
                </span>
                <span className="min-w-0 flex-1">
                  <span className="line-clamp-2 text-sm text-foreground-800 transition-colors group-hover:text-primary-700">{guide.title}</span>
                  <span className="mt-1 flex items-center gap-2 text-[11px] text-foreground-400">
                    <span>{guide.characterName}</span>
                    <span>·</span>
                    <span>{guide.readTime}</span>
                  </span>
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="overflow-hidden rounded-xl bg-gradient-to-br from-primary-600 to-primary-800 p-5 text-background-50">
        <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-background-50/15">
          <i className="ri-notification-3-line text-xl"></i>
        </span>
        <h3 className="mt-3 font-heading text-base font-bold">订阅版本情报</h3>
        <p className="mt-1.5 text-xs leading-relaxed text-background-50/80">
          第一时间获取版本前瞻、活动开启与卡池情报，不错过每一条重要信息。
        </p>
        <Link
          to="/about#contact"
          className="mt-4 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-xs font-label font-medium text-foreground-950 transition-colors hover:bg-accent-400"
        >
          <i className="ri-mail-send-line"></i>
          立即订阅
        </Link>
      </div>
    </div>
  );
}